<template>
  <main>
    <form-dialog
      class="shop-dialog"
      v-model="isActive"
      fullscreen>

      <span slot="title">{{ $t('magazzino.label.shop') }} <a class="accent--text" target="_blank" :href="fgShopHomeUri">ricambifg.com</a></span>
      <v-btn color="accent" flat @click="showNewProduct">
        <v-badge left color="accent" >
          <!-- <span slot="badge" class="caption">{{ carrello.length }}</span> -->
          <v-icon class="mr-2" size="20px">add</v-icon>
          {{ $t('magazzino.azioni.custom') }}
        </v-badge>
      </v-btn>

      <products-data-table :headers="[{text: '', value: 'src', width: 10},
                                      {text: $t('prodotti.label.sku'), value: 'sku', width: 20},
                                      {text: $t('prodotti.label.nome'), value: 'name', sortable: true, width: 50},
                                      {text: $t('prodotti.label.prezzo'), value: 'price', sortable: true, width: 10, right: true},
                                      {text: '', value: 'addable', width: 10}]"
                           :prodotti="prodotti"
                           :loading="$store.state.global.loading.prodottiShop"
                           :category.sync="category"
                           disable-clearable-category
                           :product-dialog-props="{showRipristina: true}"
                           @re-enabled="onRipristinato"
                           show-filters width-auto :title="$t('magazzino.label.shop')">

        <template slot="btn-add" slot-scope="{ item, index }">
          <v-tooltip bottom :open-delay="2000">
            <alert-chip v-if="item.attivo === false" slot="activator" color="error" class="right mr-1">
              {{ $t('prodotti.label.dismesso') }}
              <v-icon small class="ml-1" color="white">help_outline</v-icon>
            </alert-chip>
            <v-btn v-else color="accent" flat icon slot="activator" @click.stop="addToCart(item)"
                   :disabled="item.isInCart" class="my-0">
              <v-icon>add_shopping_cart</v-icon>
            </v-btn>
            <span v-if="item.attivo === false" class="text-pre-line">{{ $t('prodotti.label.dismesso_info') }}</span>
            <span v-else>{{ $t('magazzino.azioni.aggiungi_carrello') }}</span>
          </v-tooltip>
        </template>

      </products-data-table>

      <v-btn slot="btn-confirm" color="accent" flat @click="showCart">
        <v-badge left color="accent" :value="!!carrello.length">
          <span slot="badge" class="caption">{{ carrello.length }}</span>
          <v-icon class="mr-2" size="20px">shopping_cart</v-icon>
          {{ $t('magazzino.azioni.apri_carrello') }}
        </v-badge>
      </v-btn>

    </form-dialog>

    <cart-dialog :items="carrello" ref="cartDialog" @success="onAddedToLocal"/>
    <new-product-dialog ref="newProductDialog" @success="onAddedToLocal"/>

  </main>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
import FormDialog from '@/components/base/FormDialog'
import CartDialog from '@/components/CartDialog'
import ProductsDataTable from '@/components/ProductsDataTable'
import NewProductDialog from '@/components/NewProductDialog'

export default {
    name: 'ShopDialog',
    mixins: [Toggleable],
    components: { FormDialog, CartDialog, ProductsDataTable, NewProductDialog },
    data: () => ({
        category: 15, //  Categoria predefinita impostata su uggelli
        carrello: [],
        fgShopHomeUri: process.env.VUE_APP_FG_SHOP_HOME
    }),
    watch: {
        category () {
            this.fetchProdotti()
        },
        isActive (val) {
            if (val) this.fetchProdottiDismessi()
            if (val && !this.$store.getters.getProdottiShopByCategory(this.category)) this.fetchProdotti()
        }
    },
    computed: {
        prodotti () {
            let prodottiShop = this.$store.getters.getProdottiShopByCategory(this.category)
            if (!prodottiShop) {
                return []
            } else {
                return prodottiShop.map(prodotto => {
                    let isDismesso = false
                    let isInCart = false
                    if (this.$store.state.global.prodottiDismessi.length > 0 && this.$store.state.global.prodottiDismessi.findIndex(item => item.sku === prodotto.sku) !== -1) {
                        isDismesso = true
                    } else if (this.carrello.findIndex(item => item.sku === prodotto.sku) !== -1) {
                        isInCart = true
                    }
                    return {
                        ...prodotto,
                        attivo: !isDismesso,
                        isInCart
                    }
                })
            }
        }
    },
    methods: {
        show () {
            this.isActive = true
        },
        showCart () {
            this.$refs.cartDialog.show()
        },
        showNewProduct () {
            this.$refs.newProductDialog.show()
        },
        addToCart ({ id, sku, permalink, name, description, price, images, category }) {
            this.carrello.push({
                id,
                sku,
                permalink,
                name,
                description,
                price,
                category,
                src: images[0].src,
                quantita: 1,
                quantitaEditable: true
            })
        },
        onAddedToLocal () {
            this.$emit('success')
            this.isActive = false
        },
        onRipristinato () {
            this.$emit('success')
            this.fetchProdottiDismessi(true)
        },
        fetchProdotti () {
            this.$store.dispatch('loadProdottiShop', this.category).catch(e => {
                this.$snackbar.showServerError(e)
            })
        },
        fetchProdottiDismessi (forceUpdate = false) {
            this.$store.dispatch('loadProdottiDismessi', forceUpdate).catch(e => {
                this.$snackbar.showServerError(e)
            })
        }
    }
}
</script>
